import { useState } from 'react';
import { formatError } from '@/utils';

// 简化的API Hook，不使用React Query
export const useApiQuery = <T>(
  options: { queryKey?: string[]; queryFn: () => Promise<T> }
): {
  data: T | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
} => {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const refetch = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await options.queryFn();
      setData(result);
    } catch (err) {
      const errorMessage = formatError(err);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  
  return { data, isLoading, error, refetch };
};

// 简化的Mutation Hook
export const useApiMutation = <T, V = any>(
  options: { mutationFn: (variables?: V) => Promise<T>; onSuccess?: (data: T) => void }
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const mutate = async (variables?: V) => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await options.mutationFn(variables);
      if (options.onSuccess) {
        options.onSuccess(result);
      }
      return result;
    } catch (err) {
      const errorMessage = formatError(err);
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };
  
  return { mutate, isLoading, error, reset: () => setError(null) };
};

